<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Groupes de sécurité</h2>
    </div>
  </div>
  <CriteresRechercheGroupesSecurite @rechercher="rechercher" :isRechercheDataLoading="isRechercheDataLoading"/>
  <ResultatRechercheGroupesSecurite :groupesSecurites="groupesSecurites" :confidentialiteLibelles="confidentialiteLibelles"
                                    :niveauHierarchiqueLibelles="niveauHierarchiqueLibelles" :isRechercheDataLoading="isRechercheDataLoading"
                                    @removeGroupeSecuriteFromList="removeGroupeSecuriteFromList"/>
</template>

<script>
import CriteresRechercheGroupesSecurite
  from '../../../components/pilotage/GroupesSecurite/CriteresRechercheGroupesSecurite.vue'
import ResultatRechercheGroupesSecurite
  from '../../../components/pilotage/GroupesSecurite/ResultatRechercheGroupesSecurite.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheGroupesSecurite,
    ResultatRechercheGroupesSecurite
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Groupe de sécurité");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
          this.confidentialiteLibelles = res.data.entiteDecision.confidentialite.libelles;
          this.niveauHierarchiqueLibelles = res.data.entiteDecision.authorite.libelles;
        });
    this.rechercher("null");
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      groupesSecurites: [],
      isRechercheDataLoading: true,
      confidentialiteLibelles: null,
      niveauHierarchiqueLibelles: null
    }
  },
  methods: {
    rechercher(groupeSecuriteTexte) {
      this.groupesSecurites = [];
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/rechercherGroupesSecuriteAction", groupeSecuriteTexte).then((res) => {
        this.groupesSecurites = res.data;
        this.isRechercheDataLoading = false;
      });
    },
    removeGroupeSecuriteFromList(cle) {
      this.groupesSecurites = this.groupesSecurites.filter(current => (current.cle != cle))
    }
  }
}
</script>
